module.exports = {
  DefaultDashboard: '默认仪表盘',
  Edit: '编辑',
  PleaseSelectABranch: '请选择分公司',
  PleaseSelectADepartment: '请选择部门',
  PleaseChooseDepartmentPersonnel: '请选择部门人员',
  BIDashboardSource: 'BI仪表盘来源',
  SelectBIDashboardSource: '请选择BI仪表盘来源',
  BiExpiredTip: '尊敬的用户，您购买的BI模块已过期。<br>请续费后继续使用，可联系您的销售人员或联系客服。<br><div style="margin-top: 5px;">BI模块将被限制访问，数据将被保留。等续费后，可再次使用。</div>'
}
